import { Callout, H4, Intent } from '@blueprintjs/core'
import React from 'react'
import { UNKNOWN_SERVER_ERROR_CTA_MSG, UNKNOWN_SERVER_ERROR_MSG } from '../../constants/Errors'
import { camelToTitle } from '../../utils'

const ServerError = ({ message = UNKNOWN_SERVER_ERROR_MSG, cta = UNKNOWN_SERVER_ERROR_CTA_MSG }) => (
  <Callout intent={Intent.DANGER}>
    <H4>{message}</H4>
    {cta}
  </Callout>
)

const SerializedErrors = ({ safeErrors }) => (
  <ul>
    {Object.keys(safeErrors).map(key => (
      <li key={key}>
        <strong>{camelToTitle(key)} </strong>
        {safeErrors[key].join(', ')}
      </li>
    ))}
  </ul>
)

const APIErrorCallout = ({ response }) => {
  const safeData = (response && response.data) || {}
  const safeErrors = (safeData && safeData.errors) || {}
  const shouldSerialize = Object.keys(safeErrors).length > 0

  if (!response) {
    return <ServerError />
  }

  if (!response.status) {
    return <ServerError />
  }

  if (response.status >= 500) {
    return <ServerError message={safeData.message} />
  }

  return (
    <Callout intent={Intent.DANGER}>
      <H4>{safeData.message || 'Errors'}</H4>
      {shouldSerialize && <SerializedErrors safeErrors={safeErrors} />}
    </Callout>
  )
}

export default APIErrorCallout
